module.exports = __webpack_public_path__ + "img/4.a4082ec4.png";